import { api } from '@/galaxy-cruise/api';
import { IQuest, Series } from '@/galaxy-cruise/api_interface';
import { store } from '@/store';
import { Component, Vue } from "vue-property-decorator";
import Stamp from './Stamp/index.vue';

type IHistory = { [K in Series]?: IQuest[] }

@Component({
  components: { Stamp },
})
export default class extends Vue {
  get gc() {
    return store.galaxyCruise
  }

  get level() {
    return this.gc.session!.quest.level
  }

  get stamps() {
    return this.doneLevels.map((q, i) => ({
      name: q.level.stamp_name,
      date: formatDate(new Date(q.created_at)),
      seed: q.created_at,
    }))
  }

  get completed() {
    if (this.history.season_1) {
      const season_1 = this.history.season_1
      return season_1.length > 0 && season_1[season_1.length - 1].level.stamp_name === 'Aquarius Continent'
    }
    return false
  }

  history: IHistory = {}

  get doneLevels() {
    const arr: IQuest[] = []
    for (const s of Object.keys(this.history)) {
      // @ts-ignore
      const h: IQuest[] = this.history[s]
      arr.push(...h)
    }
    arr.sort((a, b) => (new Date(a.created_at)).getTime() - (new Date(b.created_at)).getTime())
    return arr
  }

  private async refresh() {
    const axios = api.default
    const history: IHistory = (await axios.get('../api/v1/history')).data
    this.history = history
  }

  mounted() {
    this.$watch(() => store.galaxyCruise.quest.id, () => {
      this.refresh()
    }, { immediate: true })
    this.$watch(() => store.galaxyCruise.seriesDone, () => {
      this.refresh()
    })
  }
}

// function randomDate() {
//   const d = new Date()
//   const ndays = 30 * Math.random()
//   d.setTime(d.getTime() - 24 * 3600 * 1000 * ndays)
//   return d
// }

function formatDate(d: Date) {
  return ` ${d.getDate()} ${monthNames[d.getMonth()]} ${d.getFullYear()}`
}

const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
